import { Deployment } from "../../../lib/src/api/partner/models/Deployment";
import { FC } from "react";
import { Domain } from "../../../lib/src/api/partner/models/Domain";
import { Site } from "../../../lib/src/api/partner/models/Site";
import { Server } from "../../../lib/src/api/partner/models/Server";
import { MailDomain } from "../../../lib/src/api/partner/models/MailDomain";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
type AnyEntity = Domain | Site | Server | MailDomain
export const FailedDeploymentBanner: FC<{ entityOrDeployment: AnyEntity | Deployment }> = ({ entityOrDeployment }) => {
  const status = entityOrDeployment instanceof Deployment ? entityOrDeployment.status : entityOrDeployment.deploymentStatus
  if (status === 'failed') {
    return <div className="bg-red-200 border border-red-700 py-3 px-4 rounded-sm flex text-red-900">
      <div className={"mr-4"}>
        <FontAwesomeIcon icon={faWarning} className={'text-xl'} />
      </div>
      <div>
        <h2 className={"font-medium"}>There was an error while applying the latest change.</h2>
        <p className={"text-sm my-1"}>
          If you have a question or need help, feel free to contact us.
        </p>
        <a className={"text-sm underline"} href={`mailto:hallo@windhoos.com?subject=Error%20${entityOrDeployment instanceof Deployment ? 'Deployment' : 'Entity'}-${entityOrDeployment.id}`}>Send us an e-mail</a>
      </div>
    </div>
  }
  return <></>
}
